export default "<p>\n  {{'loading' | translate}}\n</p>\n"